export async function fetchSessionFromApi() {
  const response = await fetch('/api/auth/session', {
    credentials: 'include'
  })

  if (!response.ok) return null

  const session = await response.json()
  if (!session?.user) return null

  return session
}
